// extracted by mini-css-extract-plugin
export default {"risk-ref-advancefilter-drawer":"RiskRefTaxonomy_risk-ref-advancefilter-drawer__anwJr","custom-width":"RiskRefTaxonomy_custom-width__fGzkD"};